/*
 * Copyright 2022. NXGN Management, LLC. All Rights Reserved.
 */

import { Component, Input } from "@angular/core";
import { Merchant } from "../../../models";

@Component({
  selector: "app-legal-entity",
  templateUrl: "./legal-entity.component.html"
})
export class LegalEntityComponent {
  @Input("merchant") merchant!: Merchant;
}
